import React from "react";
import { SettingsPanel } from "../../../Data/partials";

export default () => {
	return <SettingsPanel isEmbed={true} />;
};
